<template lang="html">
  <div class='hosts'>
    <div class="titleBloc d-flex flex-column justify-content-center">
      <div class="title">{{ $tlang(lg1, 'mercure.rates.rightTitles.host') }}</div>
      <div class="subtitle">{{ $tlang(lg2, 'mercure.rates.rightTitles.host') }}</div>
    </div>
    <div class='host d-flex flex-column justify-content-around' v-for='(host, index) in hostsLg.lg1.inCharge' v-if='host.contact_value'>
      <div class='name'>{{host.contact_value}}</div>
      <div class='job lg1'>{{host.label_value}}</div>
      <div class='job lg2'>{{hostsLg.lg2.inCharge[index].label_value}}</div>
    </div>
  </div>
</template>

<script lang="js">
  export default {
    name: 'hosts',
    props: ['hostsLg', 'rightTitle'],
    mounted () {
    },
    data () {
      return {
      }
    },
    methods: {
    },
    computed: {
      lg1 () {
        return this.$store.getters.site.get('rates').get('data').languages[0].name.toLowerCase()
      },
      lg2 () {
        return this.$store.getters.site.get('rates').get('data').languages[1].name.toLowerCase()
      }
    }
}
</script>

<style scoped lang="scss">
  $srcWidth: 1920;
  $srcHeight: 1080;
  @import "../../../../../_ibis.scss";

  .hosts {
    margin-top: 50 * 90vh / $srcHeight;
    @include heightPercent(651);
    @include widthPercent(386);
    border-top: 1px solid $purple;
    font-family: 'HouschkaAltPro-Medium';

    .host {
      border-bottom: 1px solid $purple;
      @include heightPercent(130);

      .name {
        color: $purple;
        margin-top: 1rem;
        font-size: 1rem;
      }

      .job {
        font-size: 0.95rem;
        text-transform: uppercase;

        &.lg2 {
          margin-bottom: 1rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ibis/rates/horizontal/v1/right/hosts/hosts.vue